module.exports = __webpack_public_path__ + "img/settings-fill.f2935988.svg";